module.exports = {
	"ha": "vcha",
	"id": 5.1,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 330,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.1 Estimated Cascade of Care for Vancouver Coastal Health, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -85,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.1147943523634,
						"dataLabels": {
							"enabled": true,
							"format": "4746"
						}
					},
					{
						"y": 85.22611008798854,
						"dataLabels": {
							"enabled": true,
							"format": "4165"
						}
					},
					{
						"y": 81.3587067730714,
						"dataLabels": {
							"enabled": true,
							"format": "3976"
						}
					},
					{
						"y": 75.87476979742172,
						"dataLabels": {
							"enabled": true,
							"format": "3708"
						}
					},
					{
						"y": 66.13464293022304,
						"dataLabels": {
							"enabled": true,
							"format": "3232"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.8852056476365906,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.24188790560472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.537815126050415,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.7404426559356185,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.837108953613807,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "<br>n=4887"
			}
		],
		"dataTable": {
			"Overall HA": [
				4887,
				4746,
				4165,
				3976,
				3708,
				3232
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_1.json
// module id = 301
// module chunks = 0